import { emptyTask, Task } from "../interfaces/Task";
import { useEffect, useState } from "react";
import { User, emptyUser } from "../interfaces/User";
import parse from 'html-react-parser';
import { Link, useNavigate, useParams } from "react-router-dom";
import { MainLayout } from "../layout/MainLayout";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import logo from '../../logo.svg';

export default function DoShareTask() {
    const { t } = useTranslation();

    const params= useParams();
    const navigate = useNavigate();

    const userId = localStorage.getItem('userId');

    const [user, setUser] = useState<User>(emptyUser);
    const [sharedPossible, setSharedPossible] = useState(false);
    const [task, setTask] = useState<Task>(emptyTask);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    
    const [orgShare, setOrgShare] = useState(false);
    
    const handleAccept = () => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            body: JSON.stringify({
                task: params.id,
                users: [userId]
            })
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task-shares/share-one/' + userId + '/' + params.id, requestOptions)
            .then(response => {
                navigate('/dashboard');        
            })
            .catch(error => {
                navigate('/');
            });
    }

    const handleReject = () => {
        navigate('/dashboard');
    }

    useEffect(() => {
        const userId = localStorage.getItem('userId') ?? null;

        if (userId) {
            setIsLoggedIn(true);
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/task-shares/task/' + userId + '/' + params.id, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.length == 0) {
                        // Task is not shared with the user
                        setSharedPossible(true);

                        const requestOptionsPost = {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + localStorage.getItem('token')
                            }
                        };
                        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + params.id, requestOptionsPost)
                            .then(response => {
                                if (response.status !== 200) {
                                    navigate('/');
                                }
                                return response.json();
                            })
                            .then(data => {
                                if (data.aims === undefined) {
                                    data.aims = [];
                                }
                                if (data.proficiency_level === undefined) {
                                    data.proficiency_level = [];
                                }
                                setTask(data);
                            });
                    }
                });
        }
    }, []);

    return (
        <>
            { isLoggedIn &&
                <MainLayout>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="sharing-info-container">
                                <div className="inner">
                                    <h4>{ t("Shared task") }</h4>
                                    { !sharedPossible &&
                                        <div className="message">
                                            <p>{ parse(t("The task") + ' ' + '<strong>' + task.name + '</strong> ' + t("is already shared with you.")) }</p>
                                        </div>
                                    }
                                    { sharedPossible && task._id != '' &&
                                        <div className="message">
                                            <p>{ parse(t("Do you want to add the task") + ' ' + '<strong>' + task.name + '</strong> ' + t("to the collection of tasks shared with you?")) }</p>
                                            <p>{ parse(t("If you accept, you will find this task in the 'Shared with me' section. From there you will be able to clone it and create your own version of the task.")) }</p>
                                        </div>
                                    }
                                    { sharedPossible && task._id != '' &&
                                        <div className="actions">
                                            <Button onClick={ handleAccept } variant="primary">{ t("Accept") }</Button>
                                            <Button onClick={ handleReject } variant="secondary">{ t("Reject") }</Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </MainLayout>
            }
            { !isLoggedIn &&
                <div className="do-share-task-container">
                    <div className="inner">
                        <div className="logo">
                            <img alt="Task-Gen" src= {logo}/>
                        </div>
                        <div className="message">
                            { t("To use this link, you must have a TaskGen account. Go to the login page and access with your account or register.")}
                        </div>
                        <div className="actions">
                            <Link to="/" className="btn btn-primary">{ t("Login or register") }</Link>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}